<ng-container *ngIf="totalPage > 1">
    <ul class="pagination__list">
        <li class="pagination__item static__item" (click)="selectPage(1)"><mat-icon>first_page</mat-icon></li>
        <li class="pagination__item static__item" (click)="previousPage()"><mat-icon>keyboard_arrow_left</mat-icon></li>
        <li class="pagination__item" *ngFor="let page of pages" (click)="selectPage(page.label)"
            [class.active]="page.label === actuallyPage">{{page.label}}</li>
        <li class="pagination__item static__item" (click)="nextPage()"><mat-icon>keyboard_arrow_right</mat-icon></li>
        <li class="pagination__item static__item" (click)="selectPage(totalPage)"><mat-icon>last_page</mat-icon></li>
    </ul>
</ng-container>